// extracted by mini-css-extract-plugin
module.exports = {"viewports":"\"../../../../viewports.css\"","desktop":"1024px","form-builder-container":"builder_form-builder-container__2nzec","disabled":"builder_disabled__3ejDG"};